import { render, staticRenderFns } from "./LinkedObject.vue?vue&type=template&id=793a38c7&scoped=true&"
import script from "./LinkedObject.vue?vue&type=script&lang=js&"
export * from "./LinkedObject.vue?vue&type=script&lang=js&"
import style0 from "./LinkedObject.vue?vue&type=style&index=0&id=793a38c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a38c7",
  null
  
)

export default component.exports